import RequestStatus from "../model/RequestStatus";
import {GetProductPageDataResponse} from "../model/ProductMatch";
import {PRODUCT_DATA_QUERY_START} from "src/actions/ProductSearchAction";
import {
    GENERAL_PRODUCT_DATA_QUERY_FAILED,
    GENERAL_PRODUCT_DATA_QUERY_START,
    GENERAL_PRODUCT_DATA_QUERY_SUCCESS,
    GetGeneralProductDataQueryComplete
} from "src/actions/GeneralProductSearchAction";

const initialState: GetProductPageDataResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    productData: null,
};

export default (
    state: GetProductPageDataResponse = initialState,
    action: GetGeneralProductDataQueryComplete
): GetProductPageDataResponse => {
    switch (action.type) {
        case PRODUCT_DATA_QUERY_START:// clear product result when start new search
            return initialState;
        case GENERAL_PRODUCT_DATA_QUERY_START:
            return {
                requestStatus: RequestStatus.LOADING,
                productData: null,
            };
        case GENERAL_PRODUCT_DATA_QUERY_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
                productData: action.productData,
            };
        case GENERAL_PRODUCT_DATA_QUERY_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                productData: null,
            };
        default:
            return state;
    }
};

